export default function selectLinkedSection(pages, sectionId, thisSectionData) {

  if (!pages) return thisSectionData;

  let thisSection;
  // let thisPageId;

  // function getSetcion(page) {
  //   if (!page.sections) return;
  //   for (let j = 0; j < page.sections.length; j++) {
  //     if (page.sections[j].sectionId === sectionId) {
  //       thisPageId = page.pageId;
  //       thisSection = page.sections[j];
  //     }
  //   }
  // }

  for (let i = 0; i < pages.length; i++) {
    if (pages[i].sectionId === sectionId) return pages[i];
    // if (pageId && pageId === pages[i].pageId) getSetcion(pages[i]);
    // if (!pageId) getSetcion(pages[i]);
    // if (thisSection) break;
  }

  return thisSectionData;

  // return {
  //   'section': thisSection,
  //   'pageId': thisPageId
  // };
}

//*** Not sure what to do wth commented code */
